import { AuthCountryResponse } from 'types'

export const AUTH_COUNTRY_DEFAULT: AuthCountryResponse = {
  flag_url:
    'https://cdn.countryflags.com/thumbs/indonesia/flag-400.png',
  country_id: 'ID',
  country_name: 'Indonesia',
  dial_code: '62',
}
